import React from "react";
import { Sparkles, GraduationCap, Users, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: Sparkles,
    title: "Identification",
    text: "Révéler les talents, les passions, les savoirs de chaque femme.",
  },
  {
    icon: GraduationCap,
    title: "Formation",
    text: "Ateliers artisanat, cuisine, soin — transmettre des compétences concrètes.",
  },
  {
    icon: Users,
    title: "Réseau",
    text: "Connecter à un réseau d'entrepreneuses solidaires et bienveillantes.",
  },
  {
    icon: Rocket,
    title: "Lancement",
    text: "Accompagner la création d'une activité professionnelle viable.",
  },
];

const COOK_IMG =
  "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/7cgxaqtk_IMG-20260420-WA0009.jpg";

export default function Incubateur() {
  return (
    <section
      id="incubateur"
      data-testid="incubateur-section"
      className="relative bg-[#FAF7F2] py-24 lg:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="sdm-divider">Incubateur de projets féminins</p>
            <h2 className="font-serif-display text-4xl lg:text-6xl text-[#4A192C] mt-8 leading-tight">
              L&apos;autonomie,
              <br />
              <em className="text-[#C5A059]">ce nouveau territoire.</em>
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#2C1E23]/85 leading-relaxed text-lg">
            Un accompagnement sur-mesure pour que chaque femme puisse bâtir
            son indépendance économique et ouvrir, à son tour, un espace à
            d&apos;autres.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={COOK_IMG}
                alt="Atelier cuisine collective"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-[#FAF7F2]/95 px-5 py-4 border-l-4 border-[#C5A059]">
                <div className="text-[0.65rem] tracking-[0.22em] uppercase text-[#C5A059] font-semibold">
                  Atelier cuisine
                </div>
                <div className="font-serif-display text-lg text-[#4A192C] mt-1">
                  Transmettre un savoir, ouvrir un métier
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#4A192C]/15">
            {STEPS.map((s, i) => (
              <div
                key={s.title}
                data-testid={`incubateur-step-${i + 1}`}
                className="bg-[#FAF7F2] p-8 lg:p-10 hover:bg-[#F2EBE1] transition-colors group"
              >
                <div className="flex items-center justify-between">
                  <s.icon className="w-8 h-8 text-[#4A192C] group-hover:text-[#C5A059] transition-colors" />
                  <span className="font-serif-display text-2xl text-[#C5A059]/60">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl text-[#4A192C] mt-8">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#2C1E23]/80 leading-relaxed">
                  {s.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
